import Vue from "vue";
import Vuex from "vuex";
import i18n from "./modules/i18n";

Vue.use(Vuex);
function deepMerge(target, source) {
  if (isObject(target) && isObject(source)) {
    const result = { ...target }; // 先浅复制 target，保证不影响原对象

    Object.keys(source).forEach((key) => {
      const tVal = target[key];
      const sVal = source[key];

      // 如果两个都是对象，递归合并
      if (isObject(tVal) && isObject(sVal)) {
        result[key] = deepMerge(tVal, sVal);
      }
      // 如果是数组：默认 source 覆盖
      else if (Array.isArray(tVal) && Array.isArray(sVal)) {
        result[key] = [...sVal]; // 默认覆盖，也可改成 result[key] = [...tVal, ...sVal]
      }
      // 其它类型：直接覆盖
      else {
        result[key] = sVal;
      }
    });

    return result;
  } else {
    return source;
  }
}

function isObject(obj) {
  return obj && typeof obj === "object" && !Array.isArray(obj);
}

export default new Vuex.Store({
  state: {
    extras: {},
  },
  mutations: {
    setExtras(state, value) {
      // 新值覆盖同名键（实时预览生效），保留旧值独有的键（单端推送不丢另一端配置）
      state.extras = deepMerge(state.extras, value);

      console.log(state.extras);
    },
  },
  actions: {},
  modules: {
    i18n,
  },
});
